exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".payment-loader[data-v-df5255ae]{background:var(--white)}", ""]);

// exports
